import { Carousel } from 'antd';
import axios from 'axios';
import moment from 'moment';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useActives } from '../../../../../hooks/useActives';
import { useNewTheme } from '../../../../../hooks/useNewTheme';
import { financeRoutes } from '../../../../../utils/RoutesApi';
import { CardHomeData } from '../../../CardHomeData';
import { LoadingCard } from './LoadingCard';
import { LoadingCard2 } from './LoadingCard2';
import { Container, ContentCards } from './styles';
import styles from './styles.module.css';
import { useTitleAndUser } from '../../../../../hooks/userTitle';
import { baseURL } from '../../../../../utils/baseURL';
import image1 from '../../../../../assets/home/patrimonio.svg'; 
import image2 from '../../../../../assets/home/CurrencyDollar.svg'; 
import image3 from '../../../../../assets/home/PiggyBank.svg'; 
import image4 from '../../../../../assets/home/Calendar.svg'; 
import image5 from '../../../../../assets/home/CalendarDot.svg'; 
import image6 from '../../../../../assets/home/ClockCounterClockwise.svg';
import { MyGoalsBoxCard } from './MyGoalsBoxCard/index';

interface IPropsLoadingData {
  earningsReceived: boolean;
  nextEarningsReceived: boolean;
  profitability: boolean;
}

export function DataHomeResume() {
  //@ts-ignore
  const { permissions } = useTitleAndUser();
  const isBlocked =
    permissions.includes('Grátis') && !permissions.includes('Admin');
  const isAdmin = permissions.includes('Admin');

  const history = useHistory();
  //@ts-ignore
  const { isMobile } = useNewTheme();
  //@ts-ignore
  const { actives, loadingActive } = useActives();
  const [earningsReceived, setEarningsReceived] = useState(0);
  const [nextEarningsReceived, setNextEarningsReceived] = useState(0);
  const [dateLastInvestment, setDateLastInvested] = useState({
    diffDate: 0,
    lastInvestment: '',
  });
  const [loadingData, setLoadingData] = useState<IPropsLoadingData>({
    earningsReceived: false,
    nextEarningsReceived: false,
    profitability: false,
  });
  const [boxesCount, setBoxesCount] = useState(0);
  const [boxesTotalApplied, setBoxesTotalApplied] = useState(0);
  const [loadingBoxes, setLoadingBoxes] = useState(false);
  const [emergencyReserve, setEmergencyReserve] = useState(0);


    async function getBoxesResume() {
      try {
        setLoadingBoxes(true);

        const res = await axios.get(
          `${baseURL}${financeRoutes.FINANCE_BOX_LIST}`
        );

        const boxes = res.data || [];

        setBoxesCount(boxes.length);

        const { totalBoxesApplied, reserveValue } = boxes.reduce(
          (acc: any, box: any) => {
            acc.totalBoxesApplied += box.total_applied_value || 0;

            // 🔥 identifica o box de reserva
            if (box.name?.toLowerCase().includes('emergência') ||
                box.name?.toLowerCase().includes('emergencia') ||
                box.name?.toLowerCase().includes('EMERGENCIA') ||
                box.name?.toLowerCase().includes('reserva de emergencia') ||
                box.name?.toLowerCase().includes('reserva de emergência')
              ) {
              acc.reserveValue += box.total_applied_value || 0;
            }

            return acc;
          },
          { totalBoxesApplied: 0, reserveValue: 0 }
        );

        setBoxesTotalApplied(totalBoxesApplied);
        setEmergencyReserve(reserveValue);

      } catch (err) {
        console.error('Erro ao buscar boxes:', err);
      } finally {
        setLoadingBoxes(false);
      }
    }

  useEffect(() => {
    getNextEarningReceived();
    getEarningReceived();
    getLastProfit();
    getBoxesResume(); 
  }, []);

  async function getNextEarningReceived() {
    setLoadingData({
      ...loadingData,
      nextEarningsReceived: true,
    });
    await axios
      .get(`${process.env.REACT_APP_API_URL}${financeRoutes.FINANCE_PROCEEDS}`)
      .then((response) => {
        //@ts-ignore
        const reduceTotal = response.data.data.reduce(
          //@ts-ignore
          (acc, item) => acc + item.total,
          0
        );

        setNextEarningsReceived(reduceTotal);
      })
      .catch((err) => {});
    setLoadingData({ ...loadingData, nextEarningsReceived: false });
  }
  async function getEarningReceived() {
    setLoadingData({ ...loadingData, earningsReceived: true });
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}${financeRoutes.FINANCE_PROCEEDS_RECEIVED}`
      )
      .then((response) => {
        const totalReceived = response.data.data.total_periodos.reduce(
          //@ts-ignore
          (acc, item) => acc + item.total,
          0
        );
        setEarningsReceived(totalReceived);
      })
      .catch((err) => {});
    setLoadingData({ ...loadingData, earningsReceived: false });
  }

  async function getLastProfit() {
    try {
      const response = await axios.get(
        `${baseURL}${financeRoutes.LAST_PROFIT}`
      );
      const diffDay = moment().diff(
        moment(response.data.ultimo_aporte_date),
        'days'
      );
      setDateLastInvested({
        diffDate: diffDay,
        lastInvestment: response.data.ultimo_aporte_date,
      });
    } catch (error) {}
  }

  const positionsAll = Array.isArray(actives?.positionsAll)
    ? actives.positionsAll
    : [];

  const totalInvestment = positionsAll.reduce((a: number, b: any) => {
    if (b?.manual_update_value > 0) {
      return a + b.manual_update_value;
    }

    if (b?.updateValue || b?.total_investment_box_applied_value) {
      return (
        a +
        Number(b?.updateValue || 0) +
        Number(b?.total_investment_box_applied_value || 0)
      );
    }

    return a;
  }, 0);

  const totalInvestmentWithoutReserve = totalInvestment - boxesTotalApplied; // aqui se conta sem a reserva

  return (
    <Container>
      {isMobile ? (
        <>
          <Carousel
            arrows
            nextArrow={<CaretRight size={32} color="black" alt="Próximo slide" />}
            prevArrow={<CaretLeft size={32} color="black" alt="Slide anterior" />}
            autoplay
            className={styles.Container}
          >
            {loadingActive ? (
              <LoadingCard />
            ) : (
              <CardHomeData value={totalInvestment} title="Patrimônio total"  image={image1}/>
            )}
            {loadingActive ? (
              <LoadingCard />
            ) : (
              <CardHomeData
                value={totalInvestmentWithoutReserve}
                title="Carteira de investimentos"
                image={image2}
                onClick={() => {
                  if (isBlocked) {
                    return;
                  }
                  history.push('wallet');
                }}
                style={
                  !isAdmin && isBlocked
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' }
                }
              />
            )}
            {loadingActive ? (
              <LoadingCard />
            ) : (
              <CardHomeData
                value={emergencyReserve}
                title="Reserva de emergência"
                image={image3}
                onClick={() => {
                  if (isBlocked) {
                    return;
                  }
                  history.push('wallet');
                }}
                style={
                  !isAdmin && isBlocked
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' }
                }
              />
            )}
            {loadingActive ? (
              <LoadingCard />
            ) : (
              <CardHomeData
                // value={earningsReceived}
                title="Proventos recebidos - últimos 12 meses"
                image={image4}
                onClick={() => {
                  if (isBlocked) {
                    return;
                  }
                  history.push('renda-passiva');
                }}
                style={
                  !isAdmin && isBlocked
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' }
                }
                value={earningsReceived}
              />
            )}
            {loadingActive ? (
              <LoadingCard />
            ) : (
              <CardHomeData
                value={nextEarningsReceived}
                title="Próximos proventos"
                image={image5}
                onClick={() => {
                  if (isBlocked) {
                    return;
                  }
                  history.push('renda-passiva');
                }}
                style={
                  !isAdmin && isBlocked
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' }
                }
              />
            )}
            {loadingActive ? (
              <LoadingCard />
            ) : (
              <CardHomeData
                value={
                  dateLastInvestment.diffDate === 1
                    ? `${dateLastInvestment.diffDate} dia`
                    : `${dateLastInvestment.diffDate} dias`
                }
                // bigger={profitability.bigger}
                diff={dateLastInvestment.diffDate}
                title="Último aporte"
                image={image6}
                isVideo
              />
            )}
          </Carousel>
        </>
      ) : (
        <>
          {loadingActive ? (
              <LoadingCard2 />
            ) : (
            <div style={{
              display:'flex',
              flexDirection: 'row',
              gap: '16px',
              marginBottom: '16px',
            }}>
              <MyGoalsBoxCard
                totalInvestment={totalInvestment}
                emergencyReserve={emergencyReserve} //adcionei a reserva aqui
                totalInvestmentWithoutReserve={totalInvestmentWithoutReserve}
                boxesTotalApplied={boxesTotalApplied}
                boxesCount={boxesCount}
                disabled={!isAdmin && isBlocked}
                onClick={() => history.push('wallet')}
              />
              <CardHomeData
                value={emergencyReserve}
                title="Reserva de emergência"
                image={image3}
                onClick={() => {
                  if (isBlocked) {
                    return;
                  }
                    history.push('wallet');
                  }}
                  style={
                    !isAdmin && isBlocked
                      ? { cursor: 'not-allowed' }
                      : { cursor: 'pointer' }
                  }
              />
            </div>
          )}

          <ContentCards>
              {/* <CardHomeData value={totalInvestment} title="Patrimônio total" image={image1} />
              <CardHomeData
                value={totalInvestmentWithoutReserve}
                title="Carteira de investimentos"
                image={image2}
                onClick={() => {
                  if (isBlocked) {
                    return;
                  }
                  history.push('wallet');
                }}
                style={
                  !isAdmin && isBlocked
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' }
                }
              /> */}
            {/* {loadingActive ? (
              <LoadingCard />
            ) : (
              <CardHomeData
                value={totalMattress}
                title="Reserva de emergência"
                image={image3}
                onClick={() => {
                  if (isBlocked) {
                    return;
                  }
                  history.push('wallet');
                }}
                style={
                  !isAdmin && isBlocked
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' }
                }
              />
            )} */}
            {loadingActive ? (
              <LoadingCard />
            ) : (
              <CardHomeData
                // value={earningsReceived}
                title="Proventos recebidos - últimos 12 meses"
                image={image4}
                onClick={() => {
                  if (isBlocked) {
                    return;
                  }
                  history.push('renda-passiva');
                }}
                style={
                  !isAdmin && isBlocked
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' }
                }
                value={earningsReceived}
              />
            )}
            {loadingActive ? (
              <LoadingCard />
            ) : (
              <CardHomeData
                value={nextEarningsReceived}
                title="Próximos proventos"
                image={image5}
                onClick={() => {
                  if (isBlocked) {
                    return;
                  }
                  history.push('renda-passiva');
                }}
                style={
                  !isAdmin && isBlocked
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' }
                }
              />
            )}
            {loadingActive ? (
              <LoadingCard />
            ) : (
              <CardHomeData
                value={
                  dateLastInvestment.diffDate === 1
                    ? `${dateLastInvestment.diffDate} dia`
                    : `${dateLastInvestment.diffDate} dias`
                }
                // bigger={profitability.bigger}
                diff={dateLastInvestment.diffDate}
                title="Último aporte"
                image={image6}
                isVideo
              />
            )}
          </ContentCards>
        </>
      )}
    </Container>
  );
}
